import { I18n } from '@calendly/i18n'
import { Button } from '@calendly/ui/components/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@calendly/ui/components/dropdown-menu'
import { IconChevronDown } from '@calendly/ui/components/glyphs/IconChevronDown'
import { IconChevronUp } from '@calendly/ui/components/glyphs/IconChevronUp'
import { IconPlus } from '@calendly/ui/components/glyphs/IconPlus'
import { useState } from 'react'

import { QuestionTypeMenuItems } from './question_type_menu_items'
import {
  newQuestionButtonCss,
  questionTypeMenuContentCss,
  questionTypeMenuStyle,
} from './styles'

export const NewQuestionButton = ({
  disabled = false,
  onAddQuestion,
  onBeforeOpen,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (format) => {
    onAddQuestion(format)
    setIsOpen(false)
  }

  const handleTriggerClick = async () => {
    if (isOpen) {
      setIsOpen(false)
      return
    }

    if (onBeforeOpen) {
      const canOpen = await onBeforeOpen()
      if (!canOpen) return
    }

    setIsOpen(true)
  }

  const ChevronIcon = isOpen ? IconChevronUp : IconChevronDown

  return (
    <DropdownMenu isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <DropdownMenuTrigger>
        <Button
          appearance="secondary-outline"
          className={newQuestionButtonCss}
          data-testid="new-question-button"
          disabled={disabled}
          label={I18n.t('publisher.event_type_editor_crud.booking_page.new_question')}
          leadingIcon={IconPlus}
          size="small"
          trailingIcon={ChevronIcon}
          type="button"
          onClick={handleTriggerClick}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={questionTypeMenuContentCss}
        menuStyle={questionTypeMenuStyle}
        placement="bottom start"
      >
        <QuestionTypeMenuItems onSelect={handleSelect} />
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
